import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    // Decode HTML entities produced by Liquid {{ }} auto-escaping.
    // When text block settings contain HTML tags, Liquid escapes them
    // as &lt; &gt; etc. We must decode them so the browser renders
    // bullet lists, paragraphs, and other rich text correctly.
    if (this.innerHTML !== this.textContent && this.innerHTML.includes('&lt;')) {
      const decoder = document.createElement('textarea');
      decoder.innerHTML = this.innerHTML;
      this.innerHTML = decoder.value;
    }
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
